import apiClient from '../../../lib/client';

export const adminAPI = {
  getDataSources: async () => {
    const { data } = await apiClient.get('/admin/data-sources');
    return data;
  },

  getCoverageMap: async () => {
    const { data } = await apiClient.get('/admin/coverage-map');
    return data;
  },

  getDataSourceLogs: async (key, { limit = 50, offset = 0 } = {}) => {
    const { data } = await apiClient.get(`/admin/data-sources/${key}/logs`, {
      params: { limit, offset },
    });
    return data;
  },
};
